<template>
    <common-content-wrapper width="gigantic">
        <div class="ratings-summary">
            <div class="header">
                <p v-if="summarySubText" class="sub-text">
                    {{ summarySubText }}
                </p>
            </div>

            <div class="ratings-summary--container">
                <div v-for="(rating, index) in ratingsSorted" :key="rating.key" class="ratings-summary--item">
                    <div :class="textClass(rating.key)">
                        <span v-if="numberedList">{{ index + 1 }}.</span>
                        {{ rating.text }}
                    </div>
                    <div :class="gradeClass(rating.key)">
                        <common-rating-stars :rating="rating.grade"></common-rating-stars>
                    </div>
                </div>
                <div class="header">
                    <p class="text">
                        {{ summaryText }}
                    </p>
                </div>
            </div>
        </div>
    </common-content-wrapper>
</template>

<script>
    export default {
        props: {
            summaryText: { type: String, required: true },
            summarySubText: { type: String, default: '' },
            maxGrade: { type: Number, required: true },
            ratingsWithGrades: {
                type: Array,
                required: true,
            },
            numberedList: {
                type: Boolean,
                default: true,
            },
            highlightedRatingKey: {
                type: String,
                required: false,
                default: null,
            },
            highlightedRatingFirst: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            ratingsSorted() {
                if (this.highlightedRatingKey && this.highlightedRatingFirst) {
                    let indexOfHighlighted = this.ratingsWithGrades.findIndex((rating) => rating.key == this.highlightedRatingKey)

                    if (indexOfHighlighted > 0) {
                        let sorted = [...this.ratingsWithGrades]

                        return sorted.sort((a, b) =>
                            a.key === this.highlightedRatingKey ? -1 : b.key === this.highlightedRatingKey ? 1 : 0,
                        )
                    }
                }

                return this.ratingsWithGrades
            },
        },
        methods: {
            textClass(key) {
                return this.isHiglighted(key) ? 'text-highlighted' : 'text'
            },
            gradeClass(key) {
                return this.isHiglighted(key) ? 'grade-highlighted' : 'grade'
            },
            isHiglighted(key) {
                return this.highlightedRatingKey && key == this.highlightedRatingKey
            },
        },
    }
</script>
